import styled from 'styled-components';

export const StyledWarningDialogPaper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	min-width: 550px;
	min-height: 160px;

	& > *:first-child {
		margin-bottom: 22px;
	}

	& > *:last-child {
		margin-top: auto;
	}
`;
